import { useMutation, useQueryClient } from '@tanstack/react-query';
import { config } from '@shared/config';
import { queryKeys } from '@api/queryKeys';

interface ImportPermitResult {
  permitRef: string;
}

export function useImportPermit() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (file: File): Promise<ImportPermitResult> => {
      const baseUrl = config.apiBaseUrl;
      const formData = new FormData();
      formData.append('file', file);

      const response = await fetch(`${baseUrl}/holdings/avcs/permits/import`, {
        method: 'POST',
        body: formData,
      });

      if (!response.ok) {
        throw new Error(`Import failed: ${response.statusText}`);
      }

      return response.json() as Promise<ImportPermitResult>;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: queryKeys.holdings });
    },
  });
}
